import { render, staticRenderFns } from "./InventoryAjustment.vue?vue&type=template&id=f168f3f0"
import script from "./InventoryAjustment.vue?vue&type=script&lang=js"
export * from "./InventoryAjustment.vue?vue&type=script&lang=js"
import style0 from "./InventoryAjustment.vue?vue&type=style&index=0&id=f168f3f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports